export default "__VITE_ASSET__B5hziTSQ__"